import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

interface NowData {
  source: string;
  minutes: number;
  confidence_level?: number;
  why?: Record<string, any>;
}

@Component({
  selector: 'app-mode-details-modal',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './mode-details-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mode-details-modal.component.scss']
})
export class ModeDetailsModalComponent {
  @Input() show = false;
  @Input() title = '';
  @Input() nowData: NowData | null = null;
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();

  overlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }

  /** Retourne une clé de traduction (résolue au niveau du template via le pipe `translate`). */
  modeHelp(): string {
    const source = this.nowData?.source;
    if (source === 'MANUAL')  return 'componentsWizard.modeDetails.modeHelp.manual';
    if (source === 'SENSOR')  return 'componentsWizard.modeDetails.modeHelp.sensor';
    return 'componentsWizard.modeDetails.modeHelp.auto';
  }

  getWhy(key: string, fallback: any): any {
    const v = this.nowData?.why?.[key];
    if (v === null || v === undefined) return fallback;
    return typeof v === 'object' ? JSON.stringify(v) : v;
  }

  confStars(): string {
    const level = this.nowData?.confidence_level || 0;
    return '★'.repeat(level) + '☆'.repeat(3 - level);
  }

  /** Retourne une clé de traduction (résolue au niveau du template via le pipe `translate`). */
  confLabel(): string {
    const level = this.nowData?.confidence_level || 0;
    const labels = { 1: 'componentsWizard.modeDetails.confidence.low', 2: 'componentsWizard.modeDetails.confidence.medium', 3: 'componentsWizard.modeDetails.confidence.high' };
    return labels[level as keyof typeof labels] || 'componentsWizard.modeDetails.confidence.unknown';
  }

  confClass(): string {
    return `conf-${this.nowData?.confidence_level || 0}`;
  }

  /** Retourne une clé de traduction (résolue au niveau du template via le pipe `translate`). */
  confTooltip(): string {
    const level = this.nowData?.confidence_level || 0;
    const tooltips = {
      1: 'componentsWizard.modeDetails.confidenceTooltip.low',
      2: 'componentsWizard.modeDetails.confidenceTooltip.medium',
      3: 'componentsWizard.modeDetails.confidenceTooltip.high'
    };
    return tooltips[level as keyof typeof tooltips] || 'componentsWizard.modeDetails.confidenceTooltip.unknown';
  }
}